import defineComponent from 'flight';

function CustomResultPageUiTarget() {
    function formatMoney(number) {
        let space = '&nbsp;';
        let str = number.toString();
        let parts = [str.substr(0, str.length % 3)];
        str = str.substr(str.length % 3);
        while (str.length) {
            parts.push(str.substr(0, 3));
            str = str.substr(3);
        }

        let formatted = parts.join(space);
        let result = formatted + ' kr';
        return result;
    }

    let updateTimer;
    let earningsId;
    let targetValue;
    let updateTimerInterval = 5000;
    let previousRequestHasResponded = true;
    let nrOfFailures = 0;

    this.defaultAttrs({
        tickerSelector: '[data-earnings-ticker]',
        moneySelector: '#campaign-ticker-target-current-money',
        barSelector: '#campaign-ticker-target-meter-bar',
        labelSelector: '#campaign-ticker-target-meter-label'
    });

    this._initTicker = function () {
        let $container = this.select('tickerSelector');
        earningsId = $container.data('earnings-ticker');
        targetValue = $container.data('target-value');
        let totalEarnings = $container.data('total-earnings');
        this._updateUi(totalEarnings);
        updateTimer = setTimeout(this._requestTickerStatus.bind(this), updateTimerInterval);
    };

    this._requestTickerStatus = function () {
        if (previousRequestHasResponded) {
            let url = '/cache/kampanjer/earningsticker/earnings?campaigncodeids=' + earningsId;
            this.trigger(
                document,
                'ui:campaign:ticker-on-updating',
                {
                    id: earningsId,
                    url: url
                });
            previousRequestHasResponded = false;
        }

        // start again
        updateTimer = setTimeout(this._requestTickerStatus.bind(this), updateTimerInterval);
    };

    this._updateTicker = function (evt, data) {
        // update ui
        this._updateUi(data.total);

        // restart
        nrOfFailures = 0;
        previousRequestHasResponded = true;
    };

    this._updateUi = function (totalEarnings) {
        let percentDone = Math.min(100, Math.floor(100 * totalEarnings / targetValue));
        let $money = this.select('moneySelector');
        $money.html(formatMoney(totalEarnings));

        let $bar = this.select('barSelector');
        $bar.css({
            width: percentDone + '%'
        });
        let $label = this.select('labelSelector');
        $label.text(percentDone);
    };

    this._tickerFailed = function () {
        if (++nrOfFailures > 2) {
            clearTimeout(updateTimer);
        } else {
            previousRequestHasResponded = true;
        }
    };

    this.after('initialize', function () {
        this._initTicker();
        this.on(document, 'ui:campaign:ticker-updated', this._updateTicker);
        this.on(document, 'ui:campaign:ticker-failure', this._tickerFailed);
    });
}

module.exports = defineComponent.component(CustomResultPageUiTarget);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/search-result/custom-result-page-ui-target.js